var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacKfw70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "167px",
    height: "247px",
    viewBox: "-0.5 -0.5 167 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 L 3 125",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 M 3 243 C 5.14 219.44 5.2 193.38 3 125 M 3 243 C 3.42 200.72 3.53 156.84 3 125",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 103 L 83 3",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 103 M 3 103 C 20.55 82.51 36.26 60.44 83 3 M 3 103 C 23.24 79.93 41.84 54.63 83 3",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 L 163 243",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 M 3 243 C 35.84 240.91 71.2 240.07 163 243 M 3 243 C 52.22 243.64 100.82 245.19 163 243",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 243 L 163 123",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 243 M 163 243 C 161.11 215.91 161.64 194.03 163 123 M 163 243 C 162.53 196.71 163.38 151.84 163 123",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 103 L 83 3",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 103 M 163 103 C 146.96 82.44 129.49 60.96 83 3 M 163 103 C 143.34 77.55 123.58 52.3 83 3",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 108,
    width: 147,
    height: 128,
    fill: "#004c3f",
    stroke: "#004c3f",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 36 -12 L 129 61.5 L 36 135 Z",
    fill: "#004c3f",
    stroke: "none",
    transform: "rotate(-90,82.5,61.5)",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40.1 -13.65 L 126.1 54.63 L 40.1 122.91 Z",
    fill: "#ffffff",
    stroke: "none",
    transform: "rotate(-90,83.1,54.63)",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacKfw70);
export default __webpack_public_path__ + "static/media/fac_kfw70.93022aac38ad16e0cbfdd39efbdca28e.svg";
export { ForwardRef as ReactComponent };